function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 9a1 1 0 011-1h14a1 1 0 011 1v12.796c0 .86-1.012 1.319-1.659.753l-5.683-4.973a1 1 0 00-1.317 0L9.66 22.55c-.647.566-1.659.106-1.659-.753V9z",
  fill: "#2F80ED"
});

var SvgIconMarkActive = function SvgIconMarkActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggOUM4IDguNDQ3NzIgOC40NDc3MiA4IDkgOEgyM0MyMy41NTIzIDggMjQgOC40NDc3MiAyNCA5VjIxLjc5NjJDMjQgMjIuNjU1NCAyMi45ODgxIDIzLjExNDYgMjIuMzQxNSAyMi41NDg4TDE2LjY1ODUgMTcuNTc2MkMxNi4yODE1IDE3LjI0NjMgMTUuNzE4NSAxNy4yNDYzIDE1LjM0MTUgMTcuNTc2Mkw5LjY1ODUgMjIuNTQ4OEM5LjAxMTkyIDIzLjExNDYgOCAyMi42NTU0IDggMjEuNzk2MlY5WiIgZmlsbD0iIzJGODBFRCIvPgo8L3N2Zz4K";
export { SvgIconMarkActive as ReactComponent };